import _objectSpread from "@babel/runtime/helpers/objectSpread2";
import React from 'react';
import cn from 'clsx';
import { LazyImage } from '@crehana/compass.ui';
import { SPLIT_IMAGE_SIZE_48, SPLIT_IMAGE_SIZE_80 } from "./constants";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
var SplitImage = function SplitImage(_ref) {
  var src = _ref.src,
    title = _ref.title,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? 48 : _ref$size,
    _ref$grayscale = _ref.grayscale,
    grayscale = _ref$grayscale === void 0 ? true : _ref$grayscale,
    _ref$animated = _ref.animated,
    animated = _ref$animated === void 0 ? true : _ref$animated,
    className = _ref.className,
    style = _ref.style;
  var SPLIT_IMAGE_IMAGE_PARAMS = _objectSpread(_objectSpread({}, size === 48 ? {
    w: SPLIT_IMAGE_SIZE_48,
    h: SPLIT_IMAGE_SIZE_48
  } : {
    w: SPLIT_IMAGE_SIZE_80,
    h: SPLIT_IMAGE_SIZE_80
  }), {}, {
    fit: 'crop'
  });
  var COMMON_CLASSNAMES = cn('tw-absolute tw-top-0', animated && 'tw-duration-200 tw-transition-all');
  var SPLIT_IMAGE_COMMON_CLASSNAMES = cn(size === 48 ? "tw-w-4.8 tw-h-4.8" : "tw-w-7.2 tw-h-8", COMMON_CLASSNAMES);
  return /*#__PURE__*/_jsxs("div", {
    className: cn({
      'tw-w-4.8 tw-h-5.6': size === 48,
      'tw-w-8 tw-h-8': size === 80
    }, grayscale && 'tw-grayscale', className),
    style: style,
    role: "img",
    "aria-label": title,
    children: [/*#__PURE__*/_jsx(LazyImage, {
      src: src,
      alt: title,
      imgxParams: SPLIT_IMAGE_IMAGE_PARAMS,
      isTransparent: true,
      className: cn(SPLIT_IMAGE_COMMON_CLASSNAMES, '-tw-translate-x-[2px] -tw-translate-y-[2px] hover:-tw-translate-x-0 hover:-tw-translate-y-0'),
      style: {
        clipPath: 'polygon(0 0, 54% 0, 100% 0, 50% 50%, 0 50%)'
      }
    }), /*#__PURE__*/_jsx(LazyImage, {
      src: src,
      alt: title,
      imgxParams: SPLIT_IMAGE_IMAGE_PARAMS,
      isTransparent: true,
      className: cn(SPLIT_IMAGE_COMMON_CLASSNAMES, '-tw-translate-x-[4px] tw-translate-y-[4px] hover:-tw-translate-x-[2px] hover:tw-translate-y-[2px]'),
      style: {
        clipPath: 'polygon(0 50%, 50% 50%, 50% 100%, 0% 100%)'
      }
    }), /*#__PURE__*/_jsx(LazyImage, {
      src: src,
      alt: title,
      imgxParams: SPLIT_IMAGE_IMAGE_PARAMS,
      isTransparent: true,
      className: cn(SPLIT_IMAGE_COMMON_CLASSNAMES, 'tw-translate-x-[2px] tw-translate-y-[2px] hover:tw-translate-x-0 hover:tw-translate-y-0'),
      style: {
        clipPath: 'polygon(50% 50%, 100% 0, 100% 100%, 50% 100%)'
      }
    })]
  });
};
export default SplitImage;